import { render, staticRenderFns } from "./freeGoodsEdit.vue?vue&type=template&id=072a0dae&scoped=true&"
import script from "./freeGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./freeGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./freeGoodsEdit.vue?vue&type=style&index=0&id=072a0dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a0dae",
  null
  
)

export default component.exports